export default {
  methods: {
    deleteNullPrototype(params) {
      if (!(typeof params == 'object')) {
        return
      }
    
      var obj = Object.assign({}, params)
    
      for (var key in obj) {
        if (obj.hasOwnProperty(key) && (obj[key] === null || obj[key] === undefined || obj[key] === '')) {
          delete obj[key];
        }
      }
      return obj
    },
    setPrototypeNull(obj) {
      for (var i in obj) {
        obj[i] = ''
      }
    },
    delProp(obj, props) {
      var obj = Object.assign({}, obj)
      props.forEach(prop => {
        Object.keys(obj).forEach(key => {
          if (prop === key) {
            delete obj[key]
          }
        })
      })
      return obj
    },
    changeDate(time) {
      var str
      if (time) {
        var curTimestamp = parseInt(new Date().getTime() / 1000); //当前时间戳
        var second = curTimestamp - parseInt(new Date(time).getTime() / 1000); // 参数时间戳与当前时间戳相差秒数
        var date = new Date(time)
        var Y = date.getFullYear()
        if (second < 60) {
          str = '刚刚~'
        } else if (second > 60 && second < 3600) {
          str = parseInt(second / 60) + '分钟前~'
        } else if (second >= 3600 && second < 86400) {
          str = parseInt(second / 3600) + '小时前~'
        } else if (Y == new Date().getFullYear() && date.getMonth() == new Date().getMonth()) {
          str = parseInt(second / 86400) + '天前~'
        } else if (Y == new Date().getFullYear() && date.getMonth() < new Date().getMonth()) {
          str = parseInt(new Date().getMonth() - date.getMonth()) + '月前~'
        } else if (Y < new Date().getFullYear()) {
          str = '挺久了~'
        }

      }
      return str
    },
    
    getDateStr(timestamp,mark='/') {
      var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000

      let Y = date.getFullYear() + mark;

      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + mark;

      let D = date.getDate()<10?`0${date.getDate()}` : date.getDate();

      // let h = date.getHours() + ':';

      // let m = date.getMinutes() + ':';

      // let s = date.getSeconds();

      return Y + M + D;
      // return Y + M + D + h + m + s;
    },
    getTimeStr(timestamp,mark='/') {
      var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000

      let Y = date.getFullYear() + mark;

      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + mark;

      let D = date.getDate()<10?`0${date.getDate()}` : date.getDate();

      let h = date.getHours()<10?`0${date.getHours()}` : date.getHours() + ':';

      let m = date.getMinutes()<10?`0${date.getMinutes()}` : date.getMinutes() + ':';

      let s = date.getSeconds()<10?`0${date.getSeconds()}` : date.getSeconds();

      // return Y + M + D;
      return Y + M + D+' ' + h + m + s;
    }
  }
}